module.exports = __webpack_public_path__ + "static/img/nr1-15.95672ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nr1-15.png
// module id = 693
// module chunks = 0